import React from 'react';
import TypeChips from './components/TypeChips';
import RangeSliderWithInputs from './components/RangeSliderWithInputs';
import LocationPicker from './components/LocationPicker';
import AdvancedDrawer from './components/AdvancedDrawer';

const POSSESSION_TIMELINES = [
    { value: 'immediate', label: 'Immediate' },
    { value: '0-3m', label: '0-3 Months' },
    { value: '3-6m', label: '3-6 Months' },
    { value: '6-12m', label: '6-12 Months' },
    { value: '12m+', label: '12+ Months' },
    { value: 'flexible', label: 'Flexible' },
];

const PROPERTY_TYPES = [
    { value: 'flat', label: 'Flat' },
    { value: 'villa', label: 'Villa' },
    { value: 'plot', label: 'Plot' },
    { value: 'commercial', label: 'Commercial' },
];

export default function IntentBuyForm({ data, onChange }) {
    // data structure: { basics: {...}, budget: {...}, specifications: {...}, ... }

    const updateBasics = (field, value) => onChange('basics', field, value);
    const updateBudget = (field, value) => onChange('budget', field, value);
    const updateSpecs = (field, value) => onChange('specifications', field, value);

    const { basics = {}, budget = {}, specifications = {}, advanced = {} } = data;

    return (
        <div className="req-grid">
            {/* Basics Section */}
            <div className="req-col-span-2">
                <h3 className="req-section-title">Property & Location</h3>
            </div>

            <div className="req-field req-col-span-2">
                <label className="req-label">Property Types</label>
                <TypeChips
                    options={PROPERTY_TYPES}
                    value={basics.propertyTypes || []}
                    onChange={(val) => updateBasics('propertyTypes', val)}
                />
            </div>

            <div className="req-col-span-2">
                <LocationPicker
                    city={basics.city}
                    localities={basics.localities}
                    onChange={updateBasics}
                />
            </div>

            <div className="req-field req-col-span-2">
                <label className="req-label">Pincode</label>
                <input
                    type="text"
                    className="req-input"
                    placeholder="e.g. 560001"
                    value={basics.pincode || ''}
                    onChange={(e) => updateBasics('pincode', e.target.value)}
                />
            </div>

            {/* Budget & Specs */}
            <div className="req-col-span-2">
                <h3 className="req-section-title" style={{ marginTop: '12px' }}>Budget & Size</h3>
            </div>

            <RangeSliderWithInputs
                label="Budget Range"
                min={0}
                max={100} // Dynamic scaling in real app
                valueMin={budget.min}
                valueMax={budget.max}
                onChange={({ min, max }) => {
                    updateBudget('min', min);
                    updateBudget('max', max);
                }}
                unit="INR"
            />

            <RangeSliderWithInputs
                label="Area Range"
                valueMin={specifications.areaMin}
                valueMax={specifications.areaMax}
                onChange={({ min, max }) => {
                    updateSpecs('areaMin', min);
                    updateSpecs('areaMax', max);
                }}
                unit={specifications.areaUnit || 'Sqft'}
            />

            <div className="req-field">
                <label className="req-label">Possession</label>
                <select
                    className="req-input"
                    value={specifications.possessionTimeline || 'flexible'}
                    onChange={(e) => updateSpecs('possessionTimeline', e.target.value)}
                >
                    {POSSESSION_TIMELINES.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
            </div>

            <div className="req-field">
                <label className="req-label">Configuration (BHK)</label>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <input
                        type="number"
                        className="req-input"
                        placeholder="Min"
                        value={specifications.bhkMin || ''}
                        onChange={(e) => updateSpecs('bhkMin', e.target.value)}
                        style={{ flex: 1 }}
                    />
                    <input
                        type="number"
                        className="req-input"
                        placeholder="Max"
                        value={specifications.bhkMax || ''}
                        onChange={(e) => updateSpecs('bhkMax', e.target.value)}
                        style={{ flex: 1 }}
                    />
                </div>
            </div>

            {/* Advanced Drawer */}
            <div className="req-col-span-2">
                <AdvancedDrawer>
                    <div className="req-field">
                        <label className="req-label">Funding Status</label>
                        <select
                            className="req-input"
                            value={advanced.fundingStatus || 'unknown'}
                            onChange={(e) => onChange('advanced', 'fundingStatus', e.target.value)}
                        >
                            <option value="unknown">Unknown</option>
                            <option value="self">Self Funded</option>
                            <option value="loan">Loan Approved</option>
                            <option value="process_loan">Loan In-Process</option>
                        </select>
                    </div>
                </AdvancedDrawer>
            </div>
        </div>
    );
}
